import { HStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { SaleValueInfoProps } from "./types";
import { numberToBrl } from "@repo/core/utils/currency.utils";

export const SaleValueInfo = ({
  name,
  value,
  isGray = false,
  isCurrency = true
}: SaleValueInfoProps) => {
  return (
    <HStack
      p="$2"
      w="$full"
      justifyContent="space-between"
      bg={isGray ? "$backgroundLight50" : "$backgroundLight0"}
    >
      <Text fontSize="$xs">{name}</Text>
      <Text fontSize="$sm" fontWeight={500}>
        {isCurrency ? numberToBrl(value as number) : value}
      </Text>
    </HStack>
  );
};
